module.exports = __webpack_public_path__ + "img/update.8e93d834.svg";